export default __webpack_public_path__ + "static/media/pageRightBottomPolygon.61164976.svg";